import CardTitleWithIcon from "@/components/company/card-title-with-icon";
import { pickWebTrafficRows } from "@/components/company/shared/company-side-panel-helpers";
import KeyValueRow from "@/components/company/shared/key-value-row";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";
import { LineChartIcon } from "lucide-react";

type CardCompanyWebTrafficProps = {
  readonly company: CompanyDTO;
};

export default function CardCompanyWebTraffic({
  company,
}: CardCompanyWebTrafficProps) {
  const { t } = useTranslation();
  const webTraffic = company.webTraffic;
  if (!webTraffic) return null;

  const rows = pickWebTrafficRows(company, t);
  if (webTraffic.rankGlobal != null) {
    rows.push({
      label: t("company.insights.digital.globalRank"),
      value: `#${webTraffic.rankGlobal.toLocaleString()}`,
    });
  }
  if (webTraffic.rankCountry != null) {
    rows.push({
      label: t("company.insights.digital.countryRank"),
      value: `#${webTraffic.rankCountry.toLocaleString()}`,
    });
  }

  if (rows.length === 0) return null;

  return (
    <Card className="flex flex-col min-w-0 overflow-hidden">
      <CardHeader>
        <CardTitleWithIcon
          icon={LineChartIcon}
          title={t("company.insights.digital.webTraffic")}
        />
      </CardHeader>
      <CardContent>
        <div className="flex flex-col divide-y">
          {rows.map((row) => (
            <KeyValueRow key={row.label} label={row.label}>
              {row.value}
            </KeyValueRow>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
